<mat-tab-group #tabGroup class="h-100" (selectedTabChange)="onTabChange($event)">
  @if(configs?.isNextArrow){
    <mat-tab *ngFor="let tab of tabs; let i = index" [disabled]="tab.disabled">
      <ng-template mat-tab-label>
        <span class="tab-label">{{ tab.label }}</span>
        <span *ngIf="i < tabs.length - 1" class="arrow-icon">›</span>
      </ng-template>
  
      <div class="h-75 tab-content">
        <ng-container #dynamicContent></ng-container>
      </div>
    </mat-tab>
  } @else{
    <mat-tab *ngFor="let tab of tabs; let i = index" [label]="tab.label" [disabled]="tab.disabled">
      <div class="h-75 tab-content">
        <ng-container #dynamicContent></ng-container>
      </div>
    </mat-tab>
  }
  
</mat-tab-group>

<!-- <mat-tab-group #tabGroup class="h-100" (selectedTabChange)="onTabChange($event)">
 
</mat-tab-group> -->